export var generateExternalStyle = function generateExternalStyle() {
  return {
    showTakeButton: true,
    TopNavBarItemProps: {
      variant: 'button'
    }
  };
};